import {Injectable,Inject} from 'ng-metadata/core';
import {ServiceDetailsService} from '../../fullView/details/serviceDetails.service';
import {PermalinkService} from '../permalinkAction/permalink.service';
import {ChangeLangService} from '../../../infra/lang/changeLang.service';
import {IPromise} from 'angular';

@Injectable()
export class ExportExcelService {

    constructor(private serviceDetailsService: ServiceDetailsService,
        private permalinkService: PermalinkService,
        private changeLangService: ChangeLangService,
        @Inject('$state') private $state: ng.ui.IStateService,
        @Inject('$q') private $q: ng.IQService){}

    public getAvailableFields(){
        return this.serviceDetailsService.getFieldsForExcel();
    }

    public getItemsDetails(items: any): IPromise<{}>[]{
        let itemArray: any[] = this.getItemsArray(items);
        return itemArray.map(item => this.serviceDetailsService.getItemDetailsForAction(item));
    }

    public getItemsPermalinks(items: any){
        if (this.$state.current.name === 'servicesPage'){
            let spPermalink = window.location.href;
            return this.$q.when({'data': [{
                'permalink': spPermalink,
                'shortPermalink': spPermalink}]});
        } 
        let itemArray: any[] = this.getItemsArray(items);
        return this.permalinkService.getPermalinksForExcel(itemArray);
    }

    private getItemsArray(items: any): any[]{
        if(!items){
            return items;
        }
        return Array.isArray(items) ? items : [items];
    }

    public getFileNameFromHttpResponse(httpResponse: any): string {
        let contentDispositionHeader = httpResponse.headers('Content-Disposition');
        var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
    }

    public getLayoutDirection(): string{
        return this.changeLangService.direction
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/exportExcelAction/exportExcel.service.ts